import React from 'react';
import { Hero } from '../components/Hero';
import { ProblemSection } from '../components/ProblemSection';
import { OpeningLead } from '../components/OpeningLead';
import { EditorialTips } from '../components/EditorialTips';
import { PdfPreview } from '../components/PdfPreview';
import { Testimonials } from '../components/Testimonials';
import { WhatYouGet } from '../components/WhatYouGet';
import { Bonuses } from '../components/Bonuses';
import { PricingSection } from '../components/PricingSection';
import { Guarantee } from '../components/Guarantee';
import { FAQ } from '../components/FAQ';
import { PriceComparison } from '../components/PriceComparison';
import { StickyCTA } from '../components/StickyCTA';
import { SocialProofToast } from '../components/SocialProofToast';
import { Footer } from '../components/Footer';
import { OrderBumpProvider } from '../hooks/useOrderBumps';
function SalesPageContent() {
  return <div className="min-h-screen bg-cream font-sans selection:bg-sage/20" data-id="element-638">
      <Hero data-id="element-639" />
      <ProblemSection data-id="element-640" />
      <OpeningLead data-id="element-641" />
      <EditorialTips data-id="element-642" />
      <Testimonials data-id="element-643" />
      <PdfPreview data-id="element-644" />
      <WhatYouGet data-id="element-645" />
      <Bonuses data-id="element-646" />
      <PricingSection data-id="element-647" />
      <Guarantee data-id="element-648" />
      <FAQ data-id="element-649" />
      <PriceComparison data-id="element-650" />

      <Footer data-id="element-651" />
      <StickyCTA data-id="element-652" />
      <SocialProofToast data-id="element-653" />
    </div>;
}
export function SalesPage() {
  return <OrderBumpProvider data-id="element-654">
      <SalesPageContent data-id="element-655" />
    </OrderBumpProvider>;
}